<template>
  <div class="flex flex-row flex-wrap items-center justify-center pb-[40px] md:pb-[64px]">
    <h1 class="title mr-[15px] mt-[5rem]">You are not allowed to see this page</h1>
  </div>
</template>
